import { LayoutModule } from '@angular/cdk/layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxLogglyModule } from 'ngx-loggly-logger';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { BreadcrumbService } from './app.breadcrumb.service';
import { AppComponent } from './app.component';
import { MenuService } from './app.menu.service';
import { GlobalHttpInterceptor } from './core/interceptors/global-http-interceptor';
import { GoogleAnalyticsService } from './core/services/google-analytics.service';
import { CommandCenterModule } from './modules/commandCenter/command-center.module';
import { CustomerMarketingModule } from './modules/customer-marketing/customer-marketing.module';
import { CustomerModule } from './modules/customer/customer.module';
import { DefaultComponent } from './modules/default/default.component';
import { FocuspayModule } from './modules/focuspay/focuspay.module';
import { GiftModule } from './modules/gift/gift.module';
import { KioskModule } from './modules/kiosk/kiosk.module';
import { OnlineOrderModule } from './modules/online-order/online-order.module';
import { ReceiptsModule } from './modules/online-order/receipts/receipts.module';
import { PosModule } from './modules/pos/pos.module';
import { PublicModule } from './modules/public/public.module';
import { QuoteViewerModule } from './modules/quote-viewer/quote-viewer.module';
import { SubscriptionModule } from './modules/subscription/subscription.module';
import { UserLoginModule } from './modules/user-login/user-login.module';
import { AdminSidebarComponent } from './shared/components/admin-sidebar/admin-sidebar.component';
import { PaymentsModule } from './shared/shared/payments.module';
import { SharedModule } from './shared/shared/shared.module';

@NgModule({
	declarations: [AppComponent, DefaultComponent, AdminSidebarComponent],
	imports: [
		AppRoutingModule,
		BrowserAnimationsModule,
		BrowserModule,
		HammerModule,
		CommandCenterModule,
		CustomerMarketingModule,
		CustomerModule,
		FocuspayModule,
		GiftModule,
		HttpClientModule,
		KioskModule,
		LayoutModule,
		NgxLogglyModule.forRoot(),
		NgxSpinnerModule,
		OnlineOrderModule,
		PaymentsModule,
		PosModule,
		PublicModule,
		QuoteViewerModule,
		ReceiptsModule,
		SharedModule,
		SubscriptionModule,
		ToastModule,
		UserLoginModule,
	],
	providers: [
		// {
		// 	provide: ErrorHandler,
		// 	useClass: GlobalErrorHandler,
		// },
		{
			provide: HTTP_INTERCEPTORS,
			useClass: GlobalHttpInterceptor,
			multi: true,
		},
		BreadcrumbService,
		GoogleAnalyticsService,
		MenuService,
		Title,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
